"use strict";
/// <summary>
/// Операции
/// Сложение и вычитание матриц — можно складывать только матрицы одинакового размера, в результате получится матрица того же размера.
/// Умножение матрицы на число — нужно умножить на это число каждый элемент матрицы.
/// Умножение матриц — матрицы можно умножить друг на друга только если число столбцов первой матрицы равно числу строк второй.
/// При этом каждый элемент получившейся матрицы, стоящий в i-й строке и j-м столбце,
/// равен сумме произведений соответствующих элементов в i-й строке первого множителя и j-м столбце второго.
/// </summary>
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixOperations = void 0;
var MatrixOperations = /** @class */ (function () {
    function MatrixOperations() {
    }
    MatrixOperations.validateMatrix = function (src, srcStart, srcRowCount, srcColCount, srcColStride, srcRowStride) {
        if (srcStart < 0 || srcStart >= src.length)
            throw new RangeError("srcStart");
        if (srcStart + (srcColCount - 1) * srcColStride < 0 || srcStart + (srcColCount - 1) * srcColStride >= src.length)
            throw new Error("srcColStride");
        if (srcStart + (srcRowCount - 1) * srcRowStride < 0 || srcStart + (srcRowCount - 1) * srcRowStride >= src.length
            || srcStart + (srcRowCount - 1) * srcRowStride + (srcColCount - 1) * srcColStride < 0
            || srcStart + (srcColCount - 1) * srcColStride + (srcRowCount - 1) * srcRowStride >= src.length)
            throw new Error("srcRowStride");
        var gcd = MatrixOperations.gcd(srcRowStride, srcColStride);
        if (srcRowCount > Math.floor(srcColStride / gcd) && srcColCount > srcRowStride / gcd)
            throw new Error("srcRowStride");
    };
    // ── GCD (private, called by validateMatrix) ──
    MatrixOperations.gcd = function (a, b) {
        if (b === 0)
            return a;
        return MatrixOperations.gcd(b, Math.abs(a % b));
    };
    return MatrixOperations;
}());
exports.MatrixOperations = MatrixOperations;
